<template>
  <div class="my-org">
    <div class="step-box">
      <el-steps  :active="active" center>
        <el-step title="确认申报信息"></el-step>
        <el-step title="同意备案申明"></el-step>
        <el-step title="上传备案文件"></el-step>
        <!-- <el-step title="填写预案信息"></el-step> -->
      </el-steps>
      <govDetail v-if="state==1" ref="saveInfo"></govDetail>
      <comfirmFile v-if="state==2" :state="!isfalse" @change="change" :message="paren"></comfirmFile>
      <govUpload v-if="state==3" ref='configUpdate' @change="changeIDName" :num="num" :fileLists="fileLists" :subjectId="subjectId" :planType="'sudden'"></govUpload>
      <GovFillInfo v-if="state==4" ref='configGov' @change="changeData"></GovFillInfo>
    </div>
    <div class="org-control">
      <el-button @click="returnbank">返回</el-button>
      <el-button @click="editApply" v-if="state==1">编辑</el-button>
      <el-button type="primary" @click="confirm" :disabled="isfalse">{{sub_update}}</el-button>
    </div>

    <!-- <el-dialog title="请选择最终备案地" :visible.sync="dialogAuditSelect" close-on-press-escape>
      <el-radio-group v-model="auditRegion" size="mini">
          <el-radio border mini v-for="(item,i) in auditRegions" :key="i" :label="item">{{formatAuditRegion(item)}}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogAuditSelect = false">取消</el-button>
            <el-button @click="editApply">编辑</el-button>
            <el-button type="primary" @click="select_audit">确定</el-button>
      </span>
    </el-dialog> -->

    <!--政府突发-->
    <el-dialog title="备案信息确认" :visible.sync="dialogAuditSelect" close-on-press-escape>
      <div class="mg-bt10">{{formatAuditRegion(auditRegions)}}</div>
      <div class="mg-bt30">{{dealOrg}}</div>
      <div class="mg-bt30">
        <span>备案生效日期： </span>
        <el-date-picker
          size="small"
          v-model="effectiveDate"
          type="date"
          placeholder="选择备案生效日期">
        </el-date-picker>
      </div>
      <p>*说明：如即将提交的机构信息有误，请点击编辑按钮修改所属区划</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAuditSelect = false">取消</el-button>
        <el-button @click="editApply">编辑</el-button>
        <el-button type="primary" @click="select_audit">确定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="确认提交?" :visible.sync="dialogclose" size="tiny">
      <p class="p-color1">提交后信息无法修改,确认提交?</p>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogclose = false">取消</el-button>
            <el-button type="primary" @click="close">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="确认" :visible.sync="dialogdelect" size="tiny">
      <p class="p-color1">返回后将放弃当前未保存的数据，确认返回？</p>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogdelect = false">取 消</el-button>
            <el-button type="primary" @click="delect">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import govDetail from "../../components/burst/Govdetail.vue";
import comfirmFile from "../../components/weather/comfirmFile.vue";
import govUpload from "../../components/weather/govUpload2.vue";
import GovFillInfo from "../../components/burst/GovFillInfo.vue";
import weather from "../../data/emer/weather.js";
import burst from "../../data/emer/burst.js";
import moment from 'moment';

//突发 政府 预案申请
export default {
  data() {
    return {
      resubmit: false,
      instanceId:'',
      paren: "突发环境事件应急预案",
      dialogclose: false,
      dialogdelect: false,
      state: 1,
      active: 1,
      isfalse: false,
      sub_update: "下一步",
      //备案地集合
      auditRegions: [],
      //备案地
      auditRegion: {
        auditCity: null,
        auditCounty: null,
        auditProvince: null
      },
      //备案选择提示框
      dialogAuditSelect: false,
      num: 3,
      fileLists: [
        {
          type: 1,
          value: "突发环境事件应急预案备案表",
          id: "",
          fileName: "",
          required: true
        },
        {
          type: 2,
          value: "突发环境事件应急预案",
          id: "",
          fileName: "",
          required: true
        },
        {
          type: 3,
          value: "预案风险评估报告",
          id: "",
          fileName: "",
          required: false
        },
        {
          type: 4,
          value: "预案应急资源调查报告",
          id: "",
          fileName: "",
          required: false
        },
        {
          type: 5,
          value: "预案评审意见",
          id: "",
          fileName: "",
          required: true
        },
        {
          type: 8,
          value: "预案编制说明",
          id: "",
          fileName: "",
          required: false
        }
      ],
      subjectId:'',
      dealOrg:'',
      effectiveDate: sessionStorage.effectiveDate ? moment(sessionStorage.effectiveDate).format('YYYY-MM-DD') : ''
    };
  },
  created() {
    sessionStorage.setItem('simplifyFlag',1);
    this.instanceId = this.$route.query.instanceId;
    this.resubmit = !this.instanceId ? false : true;
    if (sessionStorage.step) {
      this.active = this.state = JSON.parse(sessionStorage.step);
      if (JSON.parse(sessionStorage.step) === 4) {
        this.sub_update = "提交";
      }
    } else {
      this.active = this.state = 1;
    }
    this.getSubjectId()
  },
  methods: {

    //编辑申报信息
    editApply(){
      this.$router.push('/editunit')
    },

    getSubjectId(){
      this.subjectId = sessionStorage.subjectId;
    },
    formatAuditRegion(items) {
      let label = "";
      items.forEach(item=>{
          if (item.auditProvinceName) {
            label += item.auditProvinceName;
          }
          if (item.auditCityName) {
            label += item.auditCityName;
          }
          if (item.auditCountyName) {
            label += item.auditCountyName;
          }
          label += ";"
      })
      if(label.length > 1){
        label = label.slice(0,-1);
        }
      return label;
    },
    // 下一步
    confirm() {
      (async () => {
        let activeCopy = this.active;
        ++activeCopy === 4
          ? (this.sub_update = "提交")
          : (this.sub_update = "下一步");
        let _this = this;
        let nextActive = true;
        if (this.active === 1) {
          if(this.$refs.saveInfo){
            let info = this.$refs.saveInfo.judge();
            if (info == true) {
              return;
            }
          }
        }
        if (this.active === 3) {
          this.sub_update = "下一步";
          let stateString = this.$refs.configUpdate.startUpFile();
          if (stateString == false) {
            // if (this.resubmit == true) {
            //   this.dialogclose = true;
            // } else {
              this.getAuditRegions();
              this.dialogAuditSelect = true;
            // }
            return;
          } else {
            return;
          }
        }
        if (this.active === 4) {
          this.sub_update = "提交";
          let statusData = this.$refs.configGov.submitForm();
          if (!statusData) return;
          this.save_step({
            planId: sessionStorage.planIdval,
            step: 4
          });
        }

        this.active++;
        this.state = this.active;
        if (this.state === 2) {
          this.save_step({
            planId: sessionStorage.planIdval,
            step: 2
          });
          this.isfalse = true;
        } else {
          this.isfalse = false;
        }
        if (this.state === 3) {
          this.save_step({
            planId: sessionStorage.planIdval,
            step: 3
          });
        }
      })();
    },
    changeData(val) {
      (async () => {
        let savefill = await burst.save_govInfo(val);
        if (savefill.status) {
          this.sub_update = "提交";
          this.active = this.state = 4;
        } else {
          this.$message.error(savefill.msg);
        }
      })();
    },
    // 监听勾选协议的
    change(checked) {
      checked == true ? (this.isfalse = false) : (this.isfalse = true);
    },
    changeIDName(stateID) {
      stateID === 1 ? (this.isfalse = false) : (this.isfalse = true);
    },
    // 返回
    returnbank() {
      if (this.state === 4 || this.active === 4) {
        this.dialogdelect = true;
        return;
      }
      this.active = this.state = this.active - 1;
      if (this.state === 0) {
        this.$router.go(-1);
      }
      if (this.state != 2) {
        this.isfalse = false;
      }
      if (this.state === 3) {
        this.dialogdelect = true;
      }
    },
    // 存储步骤
    save_step(params) {
      (async () => {
        let getState = await weather.save_step(params);
        if (getState.status) {
        } else {
          this.$message.error(getState.msg);
        }
      })();
    },
    getAuditRegions() {
      const params = {
        planId: sessionStorage.planIdval,
        subjectId: sessionStorage.subjectId
      };
      (async () => {
        let resp = await weather.process_audit(params);
        if (resp.status) {
          this.auditRegions = resp.data;
          this.auditRegion = this.auditRegions[0];
          var areaId = []
          this.auditRegions.forEach( el =>{
            areaId.push(el.auditCounty || el.auditCity || el.auditProvince)
          });
          this.getFirstDealorg(areaId.toString())
        } else {
          this.$message.error(resp.msg);
        }
      })();
    },

    //获取提交后第一步处理机构信息
    getFirstDealorg(areaId){
      const params = {
        groupIds: areaId,
        processKey: 'SuddenEnvEvent'
      };
      (async () => {
        let resp = await weather.process_audit_first(params);
        if (resp.status) {
          let orgList = resp.data;
          this.dealOrg = "";
          if (orgList === undefined || orgList.length == 0) {
            return;
          }
          orgList.forEach(element => {
            this.dealOrg += element.name +" ("+ element.admin +"， "+(element.phone?element.phone:element.adminTel)+");"
          });
          if(this.dealOrg.length > 1){
            this.dealOrg = this.dealOrg.slice(0,-1);
          }

        } else {
          this.$message.error(resp.msg);
        }
      })();
    },

    // 提交申请
    submitProcess(params) {
      (async () => {
        let savefill = await weather.process_submit(params);
        if (savefill.status) {
          this.$router.push("/");
        } else {
          this.dialogclose = false;
          this.$message.error(savefill.msg);
        }
      })();
    },
    // 重新提交申请
    resubmitProcess(params) {
      (async () => {
        let savefill = await weather.process_resubmit(params);
        if (savefill.status) {
          this.$router.push("/");
        } else {
          this.dialogclose = false;
          this.$message.error(savefill.msg);
        }
      })();
    },
    close() {
      if (this.resubmit == false) {
        this.submitProcess({
          planId: sessionStorage.planIdval,
          auditCounty: this.auditRegion.auditCounty,
          auditCity: this.auditRegion.auditCity,
          auditProvince: this.auditRegion.auditProvince,
          effectiveDate: this.effectiveDate ? moment(this.effectiveDate).format('YYYY-MM-DD 00:00:00') : ''
        });
      } else {
        this.resubmitProcess({
          instanceId: this.instanceId,
          planId: sessionStorage.planIdval,
          auditCounty: this.auditRegion.auditCounty,
          auditCity: this.auditRegion.auditCity,
          auditProvince: this.auditRegion.auditProvince,
          effectiveDate: this.effectiveDate ? moment(this.effectiveDate).format('YYYY-MM-DD 00:00:00') : ''
        });
      }
      sessionStorage.BoxState = true;
    },
    delect() {
      this.$router.push("/");
      sessionStorage.BoxState = false;
    },
    select_audit() {
      if (this.auditRegion == "") {
        this.$message.error("请选择最终备案地");
        return;
      }
      this.dialogAuditSelect = false;
      this.dialogclose = true;
    }
  },
  components: {
    comfirmFile,
    govDetail,
    govUpload,
    GovFillInfo
  },
  beforeRouteLeave (to, from, next) {
    if(to.path == '/editunit'){
      sessionStorage.step = this.state;
      next()
    }else{
      sessionStorage.removeItem("step")
      next()
    }
  }
};
</script>
<style lang="stylus" scoped>
.step-box {
  margin-top: 10px;
}

.step-box>div:first-child {
  width: 50%;
  margin: 0 auto;
}

.step1 {
  width: 450px;
  min-width: 450px;
  margin: 30px auto;
}

.org-control {
  width: 250px;
  margin: 0 auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// burstGovStep.vue?48975f5c